/* eslint-disable import/no-cycle */
import api from './api.service';

function get(id, params) {
  return api.get(`/editors-groups/${id}`, params);
}

function index(params) {
  return api.get('/editors-groups', params);
}
function create(params) {
  return api.post('/editors-groups', params);
}

function update(id, params) {
  return api.put(`/editors-groups/${id}/update`, params);
}

function remove(id, params) {
  return api.delete(`/editors-groups/${id}`, params);
}

function save(params) {
  return (params.id) ? update(params.id, params) : create(params);
}

function editors(id, params) {
  return api.get(`/editors-groups/${id}/editors`, params);
}

function saveEditors(id, params) {
  return api.post(`/editors-groups/${id}/editors`, params);
}

function removeEditors(id, editorId, params) {
  return api.delete(`/editors-groups/${id}/editors/${editorId}`, params);
}

export const editorsGroupService = {
  index,
  save,
  remove,
  get,
  editors,
  saveEditors,
  removeEditors,
};
